import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import logEvent from '~/util/analytics';
import Layout from '~/components/Layout/Layout';
import GetTheApp from '~/components/GetTheApp/GetTheApp';
import { initStore } from '~/state/store';
import matchupOperations from '~/state/matchup/operations';
import { selectMatchup } from '~/state/matchup/reducers';
import withState from '~/hocs/withState';

import MatchupMenu from '~/components/MatchupMenu/MatchupMenu';
import NCAABTournamentLanding from '~/components/NCAABTournamentLanding/NCAABTournamentLanding';

import css from '~/pages/content_card.scss';

const render404 = () => (
  <div className={css.cardContainer}>
    <div>
      <Head>
        <style dangerouslySetInnerHTML={{ __html: css.stylesheet }} />
      </Head>
      <h3 className={css.message}>Event not found.</h3>
    </div>
    <GetTheApp />
  </div>
);

class NCAABMatchupLanding extends React.PureComponent {
  static async getInitialProps(props) {
    if (props.leagueSlug) {
      const state = props.store.getState();
      const eventId = String(selectMatchup(state).data.id) || '';

      if (eventId !== props.query.eventId)
        await props.store.dispatch(
          matchupOperations.fetchMatchup(props.leagueSlug, props.query.eventId)
        );
    }
  }

  componentDidMount() {
    const event = this.props.event.data;
    logEvent('page_view', {
      league: 'ncaab',
      page_type: 'event_ncaab_tournament_matchup_landing',
      match_id: event.id,
    });
  }

  render() {
    const event = this.props.event.data;
    if (!event) {
      return <Layout>{render404()}</Layout>;
    }
    return (
      <Layout>
        <div style={{ padding: 10 }}>
          <MatchupMenu event={event} currentSection="tournament" />
        </div>
        <NCAABTournamentLanding />
      </Layout>
    );
  }
}

NCAABMatchupLanding.propTypes = {
  leagueSlug: PropTypes.string.isRequired,
  event: PropTypes.shape({
    data: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
  }).isRequired,
  article: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  event: selectMatchup(state),
});

NCAABMatchupLanding.displayName = 'NCAABMatchupLandingPage';

export default withState({ createStore: initStore, mapStateToProps })(NCAABMatchupLanding);
